import React from "react";
import ButtonSKA from "../Buttons/ButtonSKA";

const AreaSideButtons = ({ sideButtons, customSideButtons }) => {
    if (!sideButtons && !customSideButtons) {return null;}
    return (
        <div className='area-side-buttons'>
            {
                sideButtons ?
                    sideButtons.map((button, index) => {
                        return (
                            <ButtonSKA
                                key={index}
                                type={button.type}
                                onClick={button.onClick}
                                nameIcon={button.nameIcon}
                                text={button.text}
                                isDisabled={button.disabled}
                            />
                        );
                    })
                    :
                    customSideButtons
            }
        </div>
    );
};

export default AreaSideButtons;
